import { get } from 'lodash';
import { translate } from '../../utils/translate/translations';

export const normalizeNetPriceDisplay = (netPriceData) => {
  const unknownPrice = get(netPriceData, 'unknown');
  if (unknownPrice) {
    return netPriceData.unknown;
  }
  return get(netPriceData, 'amount.text') || translate('unknown.price.text');
};
